import React, { memo } from 'react';
import cn from 'classnames';

import { Image } from 'components';

import styles from './EventCard.module.scss';

export interface EventCardProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  /** title of the event */
  title: string;
  /** image url of the title */
  image: string;
  /** url of the event */
  url: string;
}

export const EventCard: React.FC<EventCardProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    title,
    image,
    url,
  }: EventCardProps) => {
    const contentClassNames = cn(styles.EventCard, className);

    return (
      <a target="_blank" href={url} rel="noreferrer">
        <section
          className={contentClassNames}
          style={style}
          data-testid="EventCard"
        >
          <Image src={image} alt={title} />
          <p>{title}</p>
        </section>
      </a>
    );
  }
);

EventCard.displayName = 'EventCard';
